/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.BuyerPreviewLoginRpc
 */

export const previewLoginVerifyRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.BuyerPreviewLoginRpc',
  rpcName: 'previewLoginVerify',
  auth: 'external',
  fingerprint: '3swmTSlX4NOx3mdp6hFmt7YD5Evuxlnt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};